<mat-horizontal-stepper [labelPosition]="'bottom'" #stepper linear>
  <mat-step class="completed" label="Empresa" [completed]="startup">
    <div class="titulo">
      <h1 >Escolha uma Empresa</h1>
      <div class="divisor-header"></div>
      <div class="content-main pt-4">
        <select-primecap *ngIf="startups" [dataSource]="startups" (selectItem)="recebeItem($event)" placeholder="Pesquisar Empresa"></select-primecap>
        <button-primecap (clickButton)="next(1)" class="mt-4" label="CONTINUAR"></button-primecap>
      </div>
    </div>
  </mat-step>
  <mat-step label="Valor" [completed]="valor">
    <div class="titulo">
      <h1 >Informe um valor</h1>
      <div class="divisor-header"></div>
      <div class="content-main">
        <p class="label mb-1">Empresa</p>
        <div class="group-input">
          <!-- <img height="30" [src]="logo" alt="logo"> -->
          <p class="startup">{{startup}}</p>
        </div>
      </div>
      <div class="group-valor">
        <p class="label-valor">Informe o valor que será investido</p>
        <form #valorForm="ngForm" >
          <input
          #inputValue="ngModel"
          [(ngModel)]="valor"
          name="valor"
          type="text"
          placeholder="R$ 0.000,00"
          required
          currencyMask
          >
        </form>

      </div>
      <div class="group-valor-button">
        <button-primecap buttonClass="terciario-button" (clickButton)="next(0)" class="mr-2 mt-2" label="VOLTAR"></button-primecap>
        <button-primecap [disabled]="inputValue.invalid" (clickButton)="next(2)" class="ml-2 mt-2" label="CONTINUAR"></button-primecap>
      </div>
    </div>
  </mat-step>
  <mat-step label="Investidor" [completed]="valor">
    <div class="titulo">
      <h1>Selecione um investidor</h1>
      <div class="divisor-header"></div>
      <div class="content-main">
        <div>
          <p class="label mb-1">Empresa</p>
          <div class="group-input">
            <img height="30" [src]="logo" alt="logo">
            <p class="startup">{{startup}}</p>
          </div>
        </div>
        <div class="mt-3">
          <p class="label mb-1">Valor</p>
          <div class="group-input">
            <p class="startup">{{valor | currency}}</p>
          </div>
        </div>
      </div>
    </div>
    <select-primecap [width]="'448px'" [dataSource]="investidores" (selectItem)="recebeInvestidor($event)" placeholder="Pesquisar Investidor"></select-primecap>
    <div class="group-valor-button">
      <button-primecap buttonClass="terciario-button" (clickButton)="next(1)" class="mr-2 mt-2" label="VOLTAR"></button-primecap>
      <button-primecap (clickButton)="next(3)" class="ml-2 mt-2" label="CONTINUAR"></button-primecap>
    </div>
  </mat-step>
  <mat-step label="Confirmação" [completed]="false">
    <div class="titulo">
      <h1 >Confirmação</h1>
      <div class="divisor-header"></div>
      <div class="content-main">
        <div>
          <p class="label mb-1">Empresa</p>
          <div class="group-input">
            <img height="30" [src]="logo" alt="logo">
            <p class="startup">{{startup}}</p>
          </div>
        </div>
        <div class="mt-3">
          <p class="label mb-1">Valor</p>
          <div class="group-input">
            <p class="startup">{{valor | currency}}</p>
          </div>
        </div>
        <div class="mt-3">
          <p class="label mb-1">Investidor Definido</p>
          <div class="group-input">
            <p class="startup">{{investidor}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="aviso">
      <icons-primecap name="alert"></icons-primecap>
      <div class="mensagem">
        <p class="mensagem-title">Atenção</p>
        <p class="mensagem-text">Revise as informações e garanta que o investimento esteja com os parâmetros corretos.</p>
      </div>
    </div>
    <div class="group-valor-button">
      <button-primecap buttonClass="terciario-button" (clickButton)="next(2)" class="mr-2 mt-2" label="VOLTAR"></button-primecap>
      <button-primecap (clickButton)="exibirModalPush()" class="ml-2 mt-2" label="CONTINUAR"></button-primecap>
    </div>
  </mat-step>
</mat-horizontal-stepper>
